/**
 * @Author: DKing
 * @Desc: 过滤器合集
 * @Date: 2019-07-15
 */
import Vue from 'vue'

/**
 * Desc:不识别标签转换
 * @param {String} str 需要被转换的字符
 * */
export const transformDom = (str) =>{
  var strTem = "";
  if (str.length === 0) return;
  strTem = str.replace(/&/g, "&gt;");
  strTem = strTem.replace(/</g, "&lt;");
  strTem = strTem.replace(/>/g, "&gt;");
  strTem = strTem.replace(/ /g, "&nbsp;");
  strTem = strTem.replace(/\'/g, "&#39;");
  strTem = strTem.replace(/\"/g, "&quot;");
  strTem = strTem.replace(/\n/g, "");

  return strTem
};


/**
 * Price
 * 精度 分转元
 * @param {Number,String} fen 需要被转换的分
 */
export const fenToYuan = (fen) =>{
  var num = fen;
  num=fen*0.01;
  num+='';
  var reg = num.indexOf('.') >-1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num=toDecimal2(num.replace(reg,'$1'));
  return num
};


/**
 * Price
 * 精度 元转分
 * @param {Number,String} yuan 需要被转换的元
 * */
export const yuanToFen = (yuan) =>{
  var m=0,
    s1=yuan.toString(),
    s2='100';
  try{m+=s1.split(".")[1].length}catch(e){}
  try{m+=s2.split(".")[1].length}catch(e){}
  return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
};


/**
 * Price
 * 强制保留2位小数，如：2，会在2后面补上00.即2.00
 * @param {Number,String} x 需要被转换的金钱
 * */
export const toDecimal2 = (x) => {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
};


/**
 * Form
 * 判断输入是否为合法的手机号码 true为符合
 * @param {Number,String} phoneNum
 * */
export const checkPhoneNumber = (phoneNum) => {
  var reg_mobile = /^1([358][0-9]|4[579]|66|7[01235678]|9[189])[0-9]{8}$/;

  let res = reg_mobile.test(phoneNum)
  if(!res){
    alert('手机号不正确')
  }

  return res;
};


/**
 * Form
 * 判空
 * @param {any} args
 * true为空，false为非空
*/
export const checkNull = (args) => {
  if (args === null || args === 'null' || args === undefined || args === 'undefined' || args === '' || args.length === 0 || args === {}) {
    return true;
  } else {
    return false;
  }
};


/**
 * Form
 * 身份证验证 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
 * @param {String} cardNo
 * true 为通过
 * */
export const checkIdCard = (cardNo) => {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  let res = reg.test(cardNo);
  if (!res) {
    alert('身份证号不正确')
  }

  return res
};


/**
 * Form
 * 去掉空格
 * @param {String} str [待去空格的文本]
 * */
export const trim = (str) => {
  var result;
  result = str.replace(/(^\s+)|(\s+$)/g, '');
  result = result.replace(/\s/g, '');
  return result;
};


/**
 * Form
 * 去左右两边空格
 * @param {String} str [待去空格的文本]
 * */
export const sideTrim = (str) =>{
  console.log(str)
  if (str === null || str === 'null' || str === undefined || str === 'undefined' || str === '' || str.length === 0 || str === {}) {
    return ''
  } else {
    return str.replace(/^\s+|\s+$/g,"");
  }
}

/**
 * Date
 * 日期格式化为 - 连接
 * @param {String} date
 * */
export const formatDate = (date) => {
  var Year = 0;
  var Month = 0;
  var Day = 0;
  var CurrentDate = '';
  //初始化时间
  Year = date.getFullYear();
  Month = date.getMonth() + 1;
  Day = date.getDate();
  CurrentDate += Year + '-';
  if (Month >= 10) {
    CurrentDate += Month + '-';
  }
  else {
    CurrentDate += '0' + Month + '-';
  }
  if (Day >= 10) {
    CurrentDate += Day;
  }
  else {
    CurrentDate += '0' + Day;
  }

  return CurrentDate;
};


/**
 * Date
 * 获取当月第一天
 * */
export const getCurrentMonthFirst = () => {
  var date = new Date();
  date.setDate(1);
  var month = parseInt(date.getMonth()+1);
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}

/**
 * Date
 * 获取当月最后一天
 * */
export const getCurrentMonthLast = () => {
  var date = new Date();
  var currentMonth = date.getMonth();
  var nextMonth = ++currentMonth;
  var nextMonthFirstDay= new Date(date.getFullYear(),nextMonth,1);
  var oneDay = 1000*60*60*24;
  var lastTime = new Date(nextMonthFirstDay-oneDay);
  var month= parseInt(lastTime.getMonth()+1);
  var day = lastTime.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return date.getFullYear() + '-' + month + '-' + day;
}


/**
 * 参数判空，并提示不合法字段名
 * 例：
 * params = {
 *  name: 'DKing',
 *  id:'3',
 *  age:18
 * }
 * checkedParamsArr = [
 *  {name:'名字'},
 *  {id:'id'},
 *  {age:'年龄'}
 * ]
 * 返回值
 * true：所有必填项均以填
 * false：有必填项为空
 */
export const checkParamsIsNullTipValue = (params, checkedParamsArr) => {
  let list = [];
  for(let par of checkedParamsArr){
    for(let k in par){
      let obj = {
        key: k,
        value:par[k]
      }
      list.push(obj)
    }
  }

  for(let item in params){
    if(checkNull(params[item])){
      for(let obj of list){
        if(item === obj['key']){
          console.log('不能为空',  obj['value']);
          alert(obj['value'] + '不能为空');
          return false
        }
      }
    }
  }

  return true;
};


/**
 * 参数判空
 * @param {Object} params [待校验的参数]
 * @param {Array} noCheckedParamsArr [无需校验的参数]
 * */
export const checkParamsIsNull = (params, noCheckedParamsArr) => {
  var arr = [];
  for (let item in params) {
    let listItem = {
      key: item,
      value: params[item]
    };
    if(noCheckedParamsArr.indexOf(listItem.key) < 0){
      arr.push(listItem);
    }
  }

  var resStrList = []
  for(let obj of arr){
    if (obj.value === null || obj.value === 'null' || obj.value === undefined || obj.value === 'undefined' || obj.value === '' || obj.value.length === 0) {
      // TODO 开发时将参数的值打印出来，以便定位哪个参数为空
      // alert('必填参数不能为空')
      alert(obj.key, true)

      return false
    } else {
      resStrList.push(true)
    }
  }

  if(resStrList.indexOf(false) < 0){
    return true
  }
};


// 存储localStorage
export const setLocal = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

// 得到localStorage
export const getLocal = (key) => {
  return JSON.parse(localStorage.getItem(key))
};

// 删除localStorage
export const delLocal = (key) => {
  localStorage.removeItem(key);
};

// 清空localStorage
export const clearLocal = () => {
  localStorage.clear();
};

// 存储sessionStorage
export const setSession = (key, value) => {
  sessionStorage.setItem(key, value);
};

// 得到sessionStorage
export const getSession = (key) => {
  if(checkNull(key)){
    return JSON.parse(sessionStorage.getItem(key))
  }else{
    return sessionStorage.getItem(key)
  }
  // return JSON.parse(sessionStorage.getItem(key))
};

// 删除得到sessionStorage
export const delSession = (key) => {
  return sessionStorage.removeItem(key)
};

// 判断是移动还是pc
export const deviceIsPc =() =>{
  var userAgentInfo = navigator.userAgent.toLowerCase();
  var Agents = new Array("android", "iphone", "symbianOS", "windows phone", "ipad", "ipod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
  }
  return flag;
}

// 补全路径
export const changeUrl = (url) => {
  if(!checkNull(url)){
    let isChange = url.indexOf('http');
    let urlPrefix = 'https://hvyogo-open.oss-cn-beijing.aliyuncs.com/';
    if (isChange > -1) {
      return url;
    } else if (isChange < 0) {
      return urlPrefix + url;
    }
  } else {
    return ''
  }
};

//模块跳转锚点
export const jumpAnchorPoint = (id) => {
  var anchor = document.querySelector(id);
  console.log(anchor)
  document.body.scrollTop = anchor.offsetTop; // chrome
  document.documentElement.scrollTop = anchor.offsetTop; // firefox
};

//导航中免费体验，侧边栏免费体验，产品服务，解决方案模块，首页-免费体验模块
//跳转到首页 -- form表单模块 + 链接后拼字符传
export const jumpIndexPagePoin = (source) =>{
  let location = window.location;
  let hash = location.hash;
  let path = ''

  // 1 判断是否有source参数
  if(source){

    // 2 找到是否已有参数   ？
    if(location.hash.includes('?')){

      // 4 当前hash里面是否已有source？ 有 把之前的替换成现有 ，如果没有 追加
      if(hash.indexOf('source') > -1){
        // 如果source=xxx后面没用东西  #/?key=222&source=jjfa_jsps
        // 如果source=xxx后面有东西 #/?key=222&source=jjfa_jsps&source=cpfw_yhg

        let list = hash.split('&');
        console.log('老数组：',list)
        // 6参数上面只有source
        if(list.length < 2){
          // 路由只有source  eg：["#/solutionTimelyDist?source=jjfa_tyfa"]
          hash = '?source='+ source
          console.log('只有source参数的hash：',hash)

        } else {
          // 7 参数既有source 又有其他参数
          list.forEach((item,index) =>{
            if(item.indexOf('source') > -1){
              // 8 source 是否是第一个参数，还要将前面的路由鸣唱带上，所以不能直接换
              if(item.indexOf('=') > -1){
                list[index] = item.split('=')[0]+  '=' + source
              } else {
                // 9 不是在第一个参数，就把包含source参数直接换成新的
                list[index] = 'source=' + source
              }
            }
          })
          hash = list.join('&')
          console.log('除了source还有其他参数的hash：', hash)
        }

      } else {
        // 5 没有source参数的hash
        hash = hash + '&source=' + source
        console.log('没有source参数的hash：', hash)
      }

    } else {
      // 3 任何参数都没有
      hash = '#/?source=' + source
      console.log('任何参数都没有的hash', hash)
    }

    path = '/?' + hash.split('?')[1]
    console.log('最后跳转路径:', path)
    return path;
  }
}


// 页面跳转  -- 包括PC,移动
// 1.如果路由上面带着？source的话需要每个页面都带
// 2.如果不带的话页面就不需要带
// url 需要传的跳转路径

export const changeJumpPageUrl = (url) =>{

  var pathTemp,pathName,pathUrl = null;
  var path = window.location.hash;
  pathTemp = path.substring(path.indexOf("?"));

  // 1.带着？source - 获取路径里面source后面的参数
  if(path.indexOf("source") > 0){
    console.log(path.indexOf("source") > 0)
    pathName = path.substring(path.indexOf("source"));
    pathUrl =  url + "?" + pathName;
  }else{
    pathUrl = url
  }


  return pathUrl
}


// WEBPACK FOOTER //
// ./src/filters/filters.js